import React from 'react';

interface TextProps extends React.HTMLAttributes<HTMLElement> {
  as?: keyof JSX.IntrinsicElements;
  size?: 'sm' | 'md' | 'lg';
  weight?: 'normal' | 'semibold' | 'bold';
}

const sizeClass = (size?: TextProps['size']) => {
  switch (size) {
    case 'sm':
      return 'text-sm';
    case 'lg':
      return 'text-lg';
    case 'md':
    default:
      return 'text-base';
  }
};

const weightClass = (weight?: TextProps['weight']) => {
  switch (weight) {
    case 'semibold':
      return 'font-semibold';
    case 'bold':
      return 'font-bold';
    case 'normal':
    default:
      return 'font-normal';
  }
};

export const Text: React.FC<TextProps> = ({
  as: Component = 'div',
  className = '',
  children,
  size = 'md',
  weight = 'normal',
  ...rest
}) => {
  const classes = `${sizeClass(size)} ${weightClass(weight)} ${className}`.trim();

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
};

export default Text;

